export const formatMoney = (price: any) => {
  if (price.toFixed(2) === '-0.00') {
    price = price * -1;

    return price.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
  } else if (price) {
    return price.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
  }

  return '0.00';
};

export const formatMoneyRoundOff = (price: any): number => {
  const num = Number(price);

  if (isNaN(num)) {
    return 0;
  }

  // Handle -0 (preserve sign of zero if necessary)
  if (num === 0 && 1 / num === -Infinity) {
    return 0;
  }

  return Math.round(num);
};
